import { Brain, Layout, Server, Cloud, Cpu } from "lucide-react";
import me from "../images/me.jpg";
import genereadme from "../images/genereadme.png";
import beatseeker from "../images/beatseeker.png";
import maplenest from "../images/maplenest.png";

// Skills data - Champion ability style
export const SKILLS = [
  {
    key: "P",
    name: "Soft Skills",
    icon: Brain,
    description:
      "Strong foundation in problem solving, with the ability to break down complex challenges into manageable solutions. Experienced in time management and prioritization, ensuring consistent delivery in fast-paced environments. Effective communicator and collaborative team member, able to work closely with others to build reliable and well-structured applications.",
    cooldown: "Always Active",
    position: "20%",
  },
  {
    key: "Q",
    name: "Frontend",
    icon: Layout,
    description:
      "Experienced in building modern, responsive user interfaces using React and modern JavaScript frameworks. Skilled in using Tailwind CSS and shadcn/ui to create clean, consistent designs, with experience in Figma for translating design concepts into functional, user-friendly interfaces. Focused on performance, accessibility, and maintainable component architecture.",
    cooldown: "Ready",
    position: "35%",
  },
  {
    key: "W",
    name: "Backend",
    icon: Server,
    description:
      "Strong experience in designing and developing backend systems using Node.js and Python. Comfortable building RESTful APIs, handling authentication, and working with both SQL and NoSQL databases such as MongoDB. Focused on creating scalable, reliable systems with clean architecture and efficient data handling.",
    cooldown: "Ready",
    position: "50%",
  },
  {
    key: "E",
    name: "Cloud & DevOps",
    icon: Cloud,
    description:
      "Experience working with AWS to build and deploy scalable applications, including managing storage, authentication, and data services. Familiar with containerization using Docker and implementing CI/CD workflows with GitHub Actions to streamline development and deployment processes. Focused on reliability, scalability, and maintaining efficient production environments.",
    cooldown: "Ready",
    position: "65%",
  },
  {
    key: "R",
    name: "AI",
    icon: Cpu,
    description:
      "Experienced in leveraging AI tools such as ChatGPT, Gemini, GitHub Copilot, and Cursor to enhance development workflows and productivity. Skilled in prompt engineering to effectively generate, refine, and debug code, as well as explore solutions and accelerate problem solving. I also use these tools to learn new technologies and deepen my understanding, continuously improving my development skills and adapting to new challenges.",
    cooldown: "Ready",
    position: "80%",
  },
];

// Design images from guidelines
export const IMAGES = {
  avatar: me,
  project1: maplenest,
  project2: beatseeker,
  project3: genereadme,
};

// Projects data
export const PROJECTS = [
  {
    title: "MapleNest",
    description:
      "AI-powered platform for analyzing housing demand and predicting future rent using real-world data.",
    image: IMAGES.project1,
    tags: [
      "React",
      "Node.js",
      "AzureML",
      "Azure CosmosDB",
      "Azure OpenAI",
      "Google Maps API",
    ],
    link: "https://github.com/cleobnvntra/MapleNest",
  },
  {
    title: "Beatseeker",
    description:
      "Concert-focused ticketing platform built with Django, featuring seat selection, Stripe payments, email confirmations, and PDF ticket generation.",
    image: IMAGES.project2,
    tags: ["Python", "JavaScript", "Django", "Stripe"],
    link: "https://github.com/cleobnvntra/BeatSeeker",
  },
  {
    title: "Genereadme",
    description:
      "CLI tool that generates structured README documentation from code using AI and custom prompt engineering.",
    image: IMAGES.project3,
    tags: ["JavaScript", "Node.js", "OpenAI", "CLI"],
    link: "https://github.com/cleobnvntra/genereadme",
  },
];
